<template>
  <div class="col-12 animate__animated animate__fadeIn animate__faster">
    <form
      v-if="!complete"
      @submit.prevent="submitForm"
      class="row"
      name="suggestForm">
      <div class="p-2 col-12 col-md-6">
        <label for="storeName">Store Name</label>
        <input
          type="text"
          id="storeName"
          v-model="formData.customer_name"
          class="form-control"
          disabled>
      </div>
      <div class="p-2 col-12 col-md-6">
        <label for="accountNumber">Account Number</label>
        <input
          type="text"
          id="accountNumber"
          v-model="formData.customer_id"
          class="form-control"
          disabled>
      </div>
      <div class="p-2 col-12 col-md-4">
        <label for="contactName">Contact Name</label>
        <input
          type="text"
          id="contactName"
          v-model="formData.contact_name"
          required
          maxlength="50"
          class="form-control">
      </div>
      <div class="p-2 col-12 col-md-4">
        <label for="email">Email</label>
        <input
          type="email"
          id="email"
          v-model="formData.email"
          required
          maxlength="50"
          class="form-control">
      </div>
      <div class="p-2 col-12 col-md-4">
        <label for="phone">Phone Number</label>
        <input
          type="tel"
          id="phone"
          v-model="formData.phone"
          required
          maxlength="14"
          class="form-control">
      </div>
      <div class="p-2 col-12">
        <label for="additions">Which product addition(s) would you recommend {{ company }} consider adding?</label>
        <textarea
          type="text"
          id="additions"
          v-model="formData.suggested_products"
          required
          maxlength="500"
          class="form-control"/>
      </div>
      <div class="p-2 col-12 col-md-6">
        <label for="company">Which company manufactures the product(s)?</label>
        <input
          type="text"
          id="company"
          v-model="formData.suggested_product_mfg"
          required
          maxlength="50"
          class="form-control">
      </div>
      <div class="p-2 col-12 col-md-6">
        <label for="product">What is the product number and/or UPC for the product(s)?</label>
        <input
          type="text"
          id="product"
          v-model="formData.suggested_product_numbers"
          required
          maxlength="255"
          class="form-control">
      </div>
      <div class="p-2 col-12 col-md-6">
        <label for="volume">What is your current monthly purchase volume of these products?</label>
        <input
          type="text"
          id="volume"
          v-model="formData.customer_monthly_volume"
          required
          maxlength="120"
          class="form-control">
      </div>
      <div class="p-2 col-12 col-md-6">
        <label for="cost">What cost does {{ company }} need to meet for you to remain competitive?</label>
        <input
          type="text"
          id="cost"
          v-model="formData.suggested_price"
          required
          maxlength="50"
          class="form-control">
      </div>
      <div class="p-2 col-12 col-md-6">
        <label for="contact">May we contact you, if necessary, while we research this suggestion?</label>
        <div>
          <div
            id="contact"
            class="btn-group mt-1">
            <button
              class="btn btn-primary"
              type="button"
              :class="{active: formData.contact}"
              @click="setContact(true)">
              <i class="fa fa-check-circle"/>
              YES
            </button>
            <button
              class="btn btn-primary"
              type="button"
              :class="{active: !formData.contact}"
              @click="setContact(false)">
              <i class="fa fa-times-circle"/>
              NO
            </button>
          </div>
        </div>
      </div>
      <div  
        class="col-12 text-center">
        <button
          class="btn btn-primary mt-2 w-100"
          style="max-width: 25em;">
          <i class="fa fa-paper-plane"/>
          Submit
        </button>
      </div>
    </form>
    <div
      class="row"
      v-else>
      <div class="col-12 text-center animate__animated animate__bounceIn animate__faster">
        <h4 class="text-success mt-5">
          <i class="fa fa-check-circle"/>
          Complete!
        </h4>
        <div>
          Thank you for your product suggestions we will be in touch.
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import axios from 'axios'
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';

  // Initialize
  const props = defineProps(['customer'])
  const complete = ref(false)
  const store = useStore()

  // Emits
  const emit = defineEmits(['formComplete'])

  // Computed
  const company = computed(()=>{
    return store.getters.sessionCompany
  })

  // Data
  const formData = ref({
    customer_name: props.customer.name,
    customer_id: props.customer.entity_id,
    contact: true,
    company: company.value
  })

  // Methods
  const setContact = (value)=>{
    formData.value.contact = value
  }

  const submitForm = ()=>{
    let params = {form: formData.value}
    axios.post('/api/v1/private/customer_suggestions/submit_suggestion', params)
    .then(res=>{
      if(res.data.record){
        complete.value = true
        emit('formComplete')
      }
    })
    .catch(error=>{
      console.error("Error:", error);
    })
  }
</script>